import $ from '../$';
import './each';
import './is';

$.fn.remove = function (selector) {
  return this.each((_, element) => {
    if (element.parentNode && (!selector || $(element).is(selector))) {
      element.parentNode.removeChild(element);
    }
  });
};